import Box from '@mui/material/Box';

import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
    loadRouteCards,
    selectRouteCards,
    selectRouteCardsError,
    selectRouteCardsLoading,
    selectRouteCardsPagination,
} from '../store/routeCards.reducer';
import { OnboardDevicesRouteCardsTableGrid } from '../Components/OnboardDevicesRouteCardsTableGrid';
import { RouteCardsQueryParams } from '../interfaces';
import { DEFAULT_ROUTE_CARDS_PAGE_SIZE } from '../api/getRouteCards';

export const OnboardDevicesRouteCards = () => {
    const dispatch = useAppDispatch();
    const routeCards = useAppSelector(selectRouteCards);
    const routeCardsPagination = useAppSelector(selectRouteCardsPagination);
    const routeCardsLoading = useAppSelector(selectRouteCardsLoading);
    const routeCardsError = useAppSelector(selectRouteCardsError);
    const [routeCardsQuery, setRouteCardsQuery] = useState<RouteCardsQueryParams>({
        page: 1,
        pageSize: DEFAULT_ROUTE_CARDS_PAGE_SIZE,
        sortBy: 'createdAt',
        sortOrder: 'desc',
    });

    useEffect(() => {
        const promise = dispatch(loadRouteCards(routeCardsQuery));

        return () => {
            promise.abort();
        };
    }, [dispatch, routeCardsQuery]);

    const handleRouteCardsQueryChange = useCallback((queryPatch: Partial<RouteCardsQueryParams>) => {
        setRouteCardsQuery((previousQuery) => ({
            ...previousQuery,
            ...queryPatch,
        }));
    }, []);

    const onReload = useCallback(() => {
        dispatch(loadRouteCards(routeCardsQuery));
    }, [dispatch, routeCardsQuery]);

    return (
        <Box sx={{ width: '100%', padding: '20px', height: '100vh' }}>
            <OnboardDevicesRouteCardsTableGrid
                routeCards={routeCards || []}
                pagination={routeCardsPagination}
                loading={routeCardsLoading}
                error={routeCardsError}
                query={routeCardsQuery}
                onQueryChange={handleRouteCardsQueryChange}
                onReload={onReload}
            />
        </Box>
    );
};
